import {
  STOCK_DICTIONARY_DELETE_TRANSLATION_PENDING,
  STOCK_DICTIONARY_DELETE_TRANSLATION_DISMISS_ERROR,
} from '../constants';


export function deleteTranslation( id ) {
  return (dispatch) => {
      dispatch({
          type: STOCK_DICTIONARY_DELETE_TRANSLATION_PENDING,
          data: id
      })
  }
}

export function dismissDeleteTranslationError() {
  return {
    type: STOCK_DICTIONARY_DELETE_TRANSLATION_DISMISS_ERROR
  }
}

